export enum PerformanceRating {
   Strength,
   Weakness,
   'Needs Improvement',
   'No Value',
}
